import { UserService } from './../base-services/user.service';
import { BaseComponent } from './base-component';
import { Observable, Subscription, of } from 'rxjs';
import { ViewChild, OnInit, Input, AfterViewInit } from '@angular/core';
import { BaseDataService } from './../base-services/base-data.service';
import { BaseEntity } from './../base-models/base-entity';
import { Tabs2ContainerService } from './containers/services/tabs2-container.service';
import { ActivatedRoute } from '@angular/router';
import { BaseUpdateComponent } from './base-update-component';
import { ModelData } from '../base-models/model-data';
import { FormArray, FormGroup, NgForm } from '@angular/forms';
import { DefaultUpdateButtonsComponent } from '../base-components/default-update-buttons/default-update-buttons.component';
import { DefaultListButtonsComponent } from '../base-components/default-list-buttons/default-list-buttons.component';
import { HttpErrorResponse } from '@angular/common/http';
import { MissingTranslationHandler, TranslateService } from '@ngx-translate/core';
import { ModalService } from '../base-services/modal.service';
import { ErrorHandlerService } from '../base-services/error-handler.service';
import { resolve } from 'url';
import { filter, map, switchMap, tap } from 'rxjs/operators';
import { ParentProperty } from '../base-models/parent-property';

export class BaseTabs2UpdateComponent<T extends BaseEntity>
    // extends BaseComponent
    implements OnInit, AfterViewInit
    {
        constructor(
            protected tabsContainerService2: Tabs2ContainerService<T>,
            protected baseDataService: BaseDataService
        ){}

    // constructor(
    //     protected activatedRoute: ActivatedRoute,
    //     protected tabsContainerService: Tabs2ContainerService<T>,
    //     protected baseDataService: BaseDataService,
    //     protected userService: UserService
    // ){
    //     super(activatedRoute, userService);
    // }

    //ID: number;
    @Input() modelData : ModelData

    _modelData: ModelData;
    @Input() set ModelData(value: ModelData){
        this._modelData = value;
    }

    _parentPropertyName: string;
    @Input() set ParentPropertyName(value: string){
            this._parentPropertyName = value;
            this.baseUpdateComponent.parentProperty = new ParentProperty(this._parentPropertyName, this._parentPropertyValue);
        }
    
    _parentPropertyValue: number;
    @Input() set ParentPropertyValue(value: number){
        this._parentPropertyValue = value;
        this.baseUpdateComponent.parentProperty = new ParentProperty(this._parentPropertyName, this._parentPropertyValue);
    }

    private _selectedIDSubscription: Subscription;
    private closeAfterSave: boolean = false;
    private _subscriptions: Subscription[] = [];
    private _lockUnLockSubscription: Subscription;

   
    ngOnInit(){
        // super.ngOnInit();

        // 30.09.2020
        if (this._modelData)
            this.modelData = this._modelData;
        this.defaultUpdateButtons.ButtonsConfig = this.modelData.MainList.DefaultListButtonsConfig;
        this._selectedIDSubscription = this.tabsContainerService2.SelectedID
            .subscribe(ID => {
                //this.ID = ID;
                if(ID){
                    this.baseUpdateComponent.ID = ID;

                    if (ID == -1){
                        this.defaultUpdateButtons.LockedButton = false;
                        // let buttonsConfig = this.modelData.MainList.DefaultListButtonsConfig;
                        // buttonsConfig.DeleteButtonConfig.Enable = false;
                        // buttonsConfig.AddButtonConfig.Enable = false;
                        // buttonsConfig.LockButtonConfig.Enable = false;   
                        // buttonsConfig.SaveButtonConfig.Enable = true;
                        // this.defaultUpdateButtons.ButtonsConfig = buttonsConfig;
                        this.defaultListButtonsConfigEnableDisable(false,true,false,false,false,true);
                    }
                }
            })
    }

    ngAfterViewInit(){
        this._subscriptions.push(this.baseUpdateComponent.ItemSaved
            .subscribe((item: T) => {
                this.OnItemSaved(item);
            }))
        this.baseUpdateComponent.ItemDeleted
            .subscribe((item: T) => {
                this.Close();
                this.tabsContainerService2.EmitItem(item);
            })

        this.baseUpdateComponent.SaveProcessed.subscribe(value => {
            if(value)
                this.defaultUpdateButtons.saveDisabled = false;
        })
        this.defaultUpdateButtons.AddItemClicked
            .subscribe(() => {
                this.AddItem(); 
            })
        this.defaultUpdateButtons.SaveItemClicked
            .subscribe(() => {
                this.Save();
            })
        this.defaultUpdateButtons.SaveCloseItemClicked
            .subscribe(() => {
                this.closeAfterSave = true;
                this.Save();
            })
        this.defaultUpdateButtons.CloseItemClicked
            .subscribe(() => {
                this.Close();
            })
        this.defaultUpdateButtons.PrintItemClicked
            .subscribe(() => {
                this.baseUpdateComponent.Print();
            })
        this.defaultUpdateButtons.DeleteItemClicked
            .subscribe(() => {
                this.baseUpdateComponent.Delete();
            })
        this.defaultUpdateButtons.ResetItemClicked
            .subscribe(() => {
                this.baseUpdateComponent.Reset(true)
                    .subscribe(() => {
                        this.defaultUpdateButtons.PrintButtonEnable = true;

                    });
            })

        this.defaultUpdateButtons.LockUnLockClicked
        .pipe(
            switchMap(() => this.baseUpdateComponent.LockUnLock())
        )
        .subscribe((item) => {
            if (item.ID != -1) {
            this.defaultUpdateButtons.LockedButton = item.Useridlk > 0;
            }
            // .subscribe(() => {
            //     this._lockUnLockSubscription = this.baseUpdateComponent.LockUnLock()
            //     .subscribe((item)=>{
            //         if (item.ID != -1)
            //             this.defaultUpdateButtons.LockedButton = item.Useridlk > 0;                                  
            //        }                  
            //     );
            //     // if (this._lockUnLockSubscription)
            //     //    this._lockUnLockSubscription.unsubscribe();
        })
        if (this._modelData)
            this.modelData = this._modelData;
        this.defaultUpdateButtons.ShowPrintButton = this.modelData.MainList.PrintName != null;

        

        this.baseUpdateComponent.ItemLoaded
            .subscribe((item: T) => {
                console.log('BaseTabsUpdateComponent:'+ "ItemLoaded");
                if (item.Deletable != undefined && item.Editable != undefined){
                    // let buttonsConfig = this.modelData.MainList.DefaultListButtonsConfig;
                    // buttonsConfig.DeleteButtonConfig.Enable = this.baseUpdateComponent.Item.Deletable;
                    // this.defaultUpdateButtons.ButtonsConfig.AddButtonConfig.Enable = true;
                    // this.defaultUpdateButtons.ButtonsConfig.LockButtonConfig.Enable = true;
                    // buttonsConfig.SaveButtonConfig.Enable = this.baseUpdateComponent.Item.Editable;
                    // // buttonsConfig.DeleteButtonConfig.Enable = item.Useridlk == null;
                    // // buttonsConfig.SaveButtonConfig.Enable = item.Useridlk == null;
                    // this.defaultUpdateButtons.ButtonsConfig = buttonsConfig;
                    
                    this.defaultListButtonsConfigEnableDisable(true, this.baseUpdateComponent.Item.Editable, this.baseUpdateComponent.Item.Deletable, true, true,true);

                    this.defaultUpdateButtons.LockedButton = !this.baseUpdateComponent.Item.Editable;

                    if (this.baseUpdateComponent.baseInlineContainer && this.baseUpdateComponent.baseInlineContainer.baseDetailList){
                        this.baseUpdateComponent.baseInlineContainer.baseDetailList['Disabled'] = !this.baseUpdateComponent.Item.Editable;                        
                      
                        if (item.Editable == false)
                        {
                            this.baseUpdateComponent.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.baseFormGroup.disable();
                            this.baseUpdateComponent.baseInlineContainer.baseInlineUpdateComponent.saveDisabled = true;
                        }
                        else
                        {
                            // this.baseUpdateComponent.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.saveInitialControlDisabledStatus();
                            // this.baseUpdateComponent.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.baseFormGroup.enable();
                            // this.restoreInlineControlDisabledStatus(this.baseUpdateComponent.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.baseFormGroup);
                            // this.baseUpdateComponent.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.restoreControlDisabledStatus();
                            this.baseUpdateComponent.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.baseFormGroup.enable();
                            this.baseUpdateComponent.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.restoreFormDisabledState(this.baseUpdateComponent.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.baseFormGroup, this.baseUpdateComponent.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.disabledControlsState);
                            this.baseUpdateComponent.baseInlineContainer.baseInlineUpdateComponent.saveDisabled = false;
                        }
                    }
                    
                    if (item.Editable == false)
                    {
                        this.baseUpdateComponent.baseFormGroup.disable();
                    }
                    else
                    {
                        // 01.12.2023
                        // this.baseUpdateComponent.restoreControlDisabledStatus();
                        this.baseUpdateComponent.baseFormGroup.enable();
                        this.baseUpdateComponent.restoreFormDisabledState(this.baseUpdateComponent.baseFormGroup, this.baseUpdateComponent.disabledControlsState);
                    }
                }
                
            })
    }

    ngOnDestroy(){
        if(this._selectedIDSubscription)
            this._selectedIDSubscription.unsubscribe();

        if(this._subscriptions)
            this._subscriptions.forEach((subscription: Subscription) => {
                subscription.unsubscribe();
            })
    }

    OnModelDataLoaded(){
        // super.OnModelDataLoaded();
        if (this._modelData)
            this.modelData = this._modelData;
        this.baseUpdateComponent.ModelData = this.modelData;
    }

    @ViewChild('baseUpdate', /* TODO: add static flag */ {static: true}) baseUpdateComponent: BaseUpdateComponent<T>;
    @ViewChild('defaultUpdateButtons', /* TODO: add static flag */ {static: true}) defaultUpdateButtons: DefaultUpdateButtonsComponent;
    @ViewChild('defaultListButtons', /* TODO: add static flag */ {static: true}) defaultListButtons: DefaultListButtonsComponent;

    Save(form: NgForm = null){
        //this.SaveItem();
        //if(this.baseUpdateComponent.baseFormGroup.valid)
        this.defaultUpdateButtons.saveDisabled = true;
        // let buttonsConfig = this.modelData.MainList.DefaultListButtonsConfig;
        // buttonsConfig.AddButtonConfig.Enable = true;
        // buttonsConfig.DeleteButtonConfig.Enable = true;
        // buttonsConfig.SaveButtonConfig.Enable = true;    
        // buttonsConfig.LockButtonConfig.Enable = true; 
        this.defaultListButtonsConfigEnableDisable(true, true, true, true, true,true);

        this.baseUpdateComponent.SaveItem();
        //this.tabsContainerService.ShowList();
        //this.tabsContainerService.IsUpdateTabDisabled = true;
    }

    OnItemSaved(item: T){
        this.defaultUpdateButtons.saveDisabled = false;
        // this.defaultUpdateButtons.ButtonsConfig.AddButtonConfig.Enable = true;
        // this.defaultUpdateButtons.ButtonsConfig.LockButtonConfig.Enable = true;
        // this.defaultUpdateButtons.ButtonsConfig.DeleteButtonConfig.Enable = true;
        this.defaultListButtonsConfigEnableDisable(true, true, true, true, true,true);
        this.tabsContainerService2.EmitItem(item);
        if (this._modelData)
            this.modelData = this._modelData;
        if(this.modelData.MainList.CloseAfterSave || this.closeAfterSave){
            this.tabsContainerService2.IsListTabDisabled = false;
            setTimeout(() => {
                this.tabsContainerService2.ShowList();
            }, 100);
        }
        this.tabsContainerService2.IsUpdateTabDisabled = true;
        this.closeAfterSave = false;
    }

    Close(){
        //this.baseUpdateComponent.SaveItem();
        //let close: boolean = true;
        //if(!this.baseUpdateComponent.canDeactivate())
            //if(confirm('Podaci nisu sačuvani. Ako nastative, podaci će biti izgubljeni.'))
                //close = true;
            //else
                //close = false;
        //if(close){

            //this.tabsContainerService.ShowList();
            // this.baseUpdateComponent.Reset()
            //     .subscribe(value => {
            //         if(value){
            //             this.tabsContainerService2.IsListTabDisabled = false;
            //             setTimeout(() => {
            //                 this.tabsContainerService2.ShowList();
            //             }, 100);
            //             this.tabsContainerService2.IsUpdateTabDisabled = true;
            //             this.tabsContainerService2.EmitItem(null);
            //             this.baseUpdateComponent.getViewItem();
            //         }
            //     })

              this.baseUpdateComponent.Reset()
                .pipe(
                    filter(value => !!value),
             
                    tap(() => {
                        this.tabsContainerService2.IsListTabDisabled = false;
                        this.tabsContainerService2.IsUpdateTabDisabled = true;
                    }),
             
                    switchMap(() => {
                        if (!this.modelData.MainList.SelectName) {
                            return this.baseUpdateComponent.getViewItem();
                        }
             
                        return of(null);
                    }),
             
                    tap(data => {
                        if (data) {
                            this.tabsContainerService2.EmitItem(data as T);
                        }
                    }),
             
                    tap(() => {
                        this.tabsContainerService2.ShowList();
                    })
                )
                .subscribe();

        //}
    }

    AddItem(){
        this.tabsContainerService2.AddItem();

        // let buttonsConfig = this.modelData.MainList.DefaultListButtonsConfig;
        // buttonsConfig.DeleteButtonConfig.Enable = false;
        // buttonsConfig.SaveButtonConfig.Enable = true;    
        // buttonsConfig.AddButtonConfig.Enable = false;     
        // buttonsConfig.LockButtonConfig.Enable = false;     
        // this.defaultUpdateButtons.ButtonsConfig = buttonsConfig;
        this.defaultListButtonsConfigEnableDisable(false, true, false, false, false,true);
        this.defaultUpdateButtons.LockedButton = false;

        this.baseUpdateComponent.baseFormGroup.enable();
        this.baseUpdateComponent.restoreFormDisabledState(this.baseUpdateComponent.baseFormGroup, this.baseUpdateComponent.disabledControlsState);
        if (this.baseUpdateComponent.baseInlineContainer && this.baseUpdateComponent.baseInlineContainer.baseDetailList){
            this.baseUpdateComponent.baseInlineContainer.baseDetailList['Disabled'] = false;
            // this.baseUpdateComponent.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.baseFormGroup.enable();
        }
    }

    focus(){
        this.baseUpdateComponent.focus();
    }

  defaultListButtonsConfigEnableDisable(addButton: boolean, saveButton: boolean, deleteButton: boolean, lockButton: boolean, printButton: boolean, resetButton: boolean){
        if (this._modelData)
            this.modelData = this._modelData;
        let buttonsConfig = this.modelData.MainList.DefaultListButtonsConfig;
        buttonsConfig.AddButtonConfig.Enable = addButton;
        buttonsConfig.SaveButtonConfig.Enable = saveButton;   
        buttonsConfig.DeleteButtonConfig.Enable = deleteButton;
        buttonsConfig.LockButtonConfig.Enable = lockButton;
        buttonsConfig.ResetButtonConfig.Enable = resetButton;
        this.defaultUpdateButtons.ButtonsConfig = buttonsConfig;
        this.defaultUpdateButtons.PrintButtonEnable = printButton;

    }

    
}
